import React from 'react';
import { Card, CardContent, Typography, CardActions, Button } from '@material-ui/core';
import cx from 'clsx';
import Mustache from 'mustache';
import { renderSkill } from './Answer/Skill';
export var Questionnaire = function (_a) {
    var cardId = _a.cardId, messages = _a.messages, operatorEscalationUrl = _a.operatorEscalationUrl, skillApi = _a.skillApi, onFeedback = _a.onFeedback;
    var _b = React.useState('notSelected'), state = _b[0], setState = _b[1];
    var feedback = function (action) {
        onFeedback(action, function () { return setState(action); });
    };
    return (React.createElement(Card, { className: cx('faq-questionnaire', state) },
        React.createElement(CardContent, null,
            React.createElement(Typography, { className: "faq-questionnaire__title", color: "textSecondary", align: "left", gutterBottom: true, component: "div", dangerouslySetInnerHTML: {
                    __html: Mustache.render(messages[state], { operatorEscalationUrl: operatorEscalationUrl }),
                } }),
            state === 'yes'
                ? renderSkill(skillApi, {
                    from: 'FAQ_FEEDBACK_YES',
                    text: messages.yesForm,
                    cardId: cardId,
                })
                : state === 'no'
                    ? renderSkill(skillApi, {
                        from: 'FAQ_FEEDBACK_NO',
                        text: messages.noForm,
                        cardId: cardId,
                    })
                    : null),
        state !== 'notSelected' ? null : (React.createElement(CardActions, { className: cx('faq-actions', 'faq-questionnaire__actions') },
            React.createElement(Button, { className: cx('faq-button', 'faq-questionnaire__actions__button'), variant: "contained", color: "secondary", size: "small", onClick: function () { return feedback('yes'); } }, "\u306F\u3044"),
            React.createElement(Button, { className: cx('faq-button', 'faq-questionnaire__actions__button'), variant: "contained", color: "secondary", size: "small", onClick: function () { return feedback('no'); } }, "\u3044\u3044\u3048")))));
};
//# sourceMappingURL=Questionnaire.js.map